<template>
    <div class="element" :data-required="required" :class="{ [this.type] : true, error : error.error }">
        <labelElement v-bind="resolveProps('label', this)" :error="error" />
        <placeholderElement v-bind="resolveProps('placeholder', this)" :error="error" :value="this.input" />
        <stateElement v-bind="resolveProps('state', this)" :error="error" />
        <textarea
            ref="inputRef"
            :id="`field_${this.id}`"
            :name="this.name"
            :readonly="!this.editing || this.readonly"
            :placeholder="`${this.show_placeholder ? placeholder + (required ? ' *' : '') : ''}`"
            :autocomplete="this.autocomplete"
            :maxlength="this.maxlength"
            :aria-describedby="error.error ? `error_${this.id}` : null"
            v-model="input"
            @keyup="validate"
            @blur="validate"
            @change="handleChange"
            class="input"
        />
        <errorElement v-bind="resolveProps('error', this)" :error="error" :errorId="`error_${this.id}`" />
        <maxlengthElement v-bind="resolveProps('maxlength', this)" :value="this.input" />
        <tooltipElement v-bind="resolveProps('tooltip', this)" :inline="true" />
    </div>
</template>

<script>
import {defineComponent, ref, watch, computed, inject, onMounted} from "vue";

// Our form helpers
import useFieldValidation from "formbuilder/fields/_validation";
import { propDefaults, resolveProps } from "formbuilder/fields/_props";

// Our helpers
import { mergeDeep } from "helpers/_objects";
import trans from "helpers/_translation";

import labelElement from "formbuilder/elements/LabelElement.vue";
import stateElement from "formbuilder/elements/StateElement.vue";
import placeholderElement from "formbuilder/elements/PlaceholderElement.vue";
import errorElement from "formbuilder/elements/ErrorElement.vue";
import maxlengthElement from "formbuilder/elements/MaxlengthElement.vue";
import tooltipElement from "formbuilder/elements/TooltipElement.vue";

import { observeElement } from "helpers/_observer";

export default defineComponent({
    props: mergeDeep(
        propDefaults,
        {

        }
    ),
    components: {
        labelElement,
        stateElement,
        placeholderElement,
        errorElement,
        maxlengthElement,
        tooltipElement
    },
    setup(props, { emit }) {
		const inputRef = ref();
        const input = ref("");
        const {registerValidator, validate, error} = useFieldValidation();

        watch(
            () => props.value,
            () => {
                input.value = props.value;
            },
            {
                immediate: true
            }
        );

        const required = computed(() => props.required);
        watch(
            () => props.required,
            () => {
                registerValidator(input, props);
            },
            {
                immediate: true
            }
        );

        // If we got a initial value, validate instantly
        props.value && validate();

        const placeholder = computed(() => props.translate ? trans(props.placeholder) : props.placeholder);

        const handleChange = () => {
            emit('value-change', {
                name: props.name,
                value: input.value
            });
        }

		const killswitch = inject("killswitch");
		onMounted(() => {
			if (props.readonly) {
				observeElement(inputRef.value, "value", (oldValue, newValue) => {
					if (props.value == newValue) return;
					console.error("DOM manipulation not allowed", oldValue, newValue);
					killswitch && killswitch();
				});
			}
		});

        return {
            trans,
            input,
			inputRef,
            error,
            resolveProps,
            validate,
            required,
            placeholder,

            handleChange
        };
    },
});
</script>